import style from "./GoogleMapPin.module.scss"

export default function GoogleMapPin() {
    return <div className={style.googleMapContainer}>
        <iframe className={style.googleMap} loading="lazy" allowFullScreen
                src={`https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ-0FGQYsyZUcRhyiAnhhE88Q&key=${process.env.REACT_APP_GOOGLE_MAPS_EMBED_API_KEY}`}></iframe>
    </div>
}
